export default __webpack_public_path__ + "assets/models/021ec841375d004088ac99f103ad7454.gltf";